import React, {useEffect} from 'react';

import {sendEventEmptyCartLoad} from '@optimaxdev/analytics/desktop/lib/cart/commonCartEvents';
import {sendDesktopAnalyticsEvent} from '@optimaxdev/analytics/desktop/lib/sendAnalyticsEvent/index';
import {RoundButton} from '@optimaxdev/design-system';
import {Cart, Icon} from '@optimaxdev/icons';

import {CART_EMPTY_CART} from 'constants/analytics/events/cart';
import {useGetCustomerData} from 'hooks/getCustomerData/getCustomerData';
import {useHostDispatch} from 'hooks/hostHooks/hostHooks';
import {sessionStore} from 'libs/storage/storage';
import {spawnPriorityTask} from 'libs/timers/spawnPriorityTask/spawnPriorityTask';

import {RecommendationDyHeader} from '../../features/recommendation/emptyCartDyHeader';

import s from './emptyCart.scss';

const onSendAnalytics = (e?: React.SyntheticEvent<HTMLButtonElement>) => {
    const name = e && e.currentTarget.textContent;
    sendDesktopAnalyticsEvent(CART_EMPTY_CART, name || 'Recommended For You');
};

/**
 * Shows empty cart
 */
export const EmptyCart = () => {
    const {is_logged_in: isLoggedIn} = useGetCustomerData();
    const dispatch = useHostDispatch();

    const openSignIn = () =>
        dispatch({
            payload: {
                tab: 'login',
                visible: true,
            },
            type: 'AUTH_POPUP@SET_VISIBLE',
        });

    useEffect(() => {
        spawnPriorityTask(sendEventEmptyCartLoad);
    }, []);

    useEffect(() => {
        spawnPriorityTask(() =>
            sendDesktopAnalyticsEvent(
                CART_EMPTY_CART,
                {label: isLoggedIn ? 'Logged In' : 'Guest'},
                false,
            ),
        );
    }, [isLoggedIn]);

    const onCtpRedirect = (e?: React.SyntheticEvent<HTMLButtonElement>) => {
        onSendAnalytics(e);
        sessionStore.set('ctpPlaceOfInteraction', 'Empty Cart');
    };

    return (
        <section className={s.emptyCart} data-test-name="emptyCart">
            <div className={s.emptyCartWrapper}>
                <h2 className={s.title}>
                    <Icon className={s.cartIcon} icon={Cart} aria-hidden />
                    Your cart is empty.
                </h2>
                <p className={s.text}>
                    {isLoggedIn ? (
                        'You have no items in your shopping cart.'
                    ) : (
                        <>
                            Already a member?{' '}
                            <button className={s.signInBtn} onClick={openSignIn} type="button">
                                Sign-in
                            </button>{' '}
                            to see your saved items.
                        </>
                    )}
                </p>
                <div className={s.buttons}>
                    <RoundButton
                        className={s.button}
                        href="/womens-eyeglasses"
                        onClick={onCtpRedirect}
                        renderAs="a"
                        size="medium"
                    >
                        Shop Women
                    </RoundButton>
                    <RoundButton
                        className={s.button}
                        href="/mens-eyeglasses"
                        onClick={onCtpRedirect}
                        renderAs="a"
                        size="medium"
                    >
                        Shop Men
                    </RoundButton>
                </div>
            </div>
            <RecommendationDyHeader sendDataLayer={onSendAnalytics} />
        </section>
    );
};
